export default __webpack_public_path__ + "static/media/icon_auditStatus.988b0071.svg";